import React, { ChangeEvent } from 'react';

import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import UploadIcon from '@mui/icons-material/Upload';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';
import { isDesktop } from 'react-device-detect';

import { useIntelState } from '../../../context/IntelState';
import { setEnemyData } from '../../../hooks/useEnemyData';
import { setOwnData } from '../../../hooks/useOwnData';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface Props {
  isViewingEnemy: boolean;
  handleFileUpload: (e: ChangeEvent<HTMLInputElement>) => void;
  isViewingRecent?: boolean;
}

const GridViewToolBar: React.FC<Props> = ({
  isViewingEnemy,
  handleFileUpload,
  isViewingRecent,
}) => {
  const { intelState, intelDispatch } = useIntelState();

  const refreshData = () => {
    if (isViewingEnemy) {
      setEnemyData(intelState.server, intelState.enemyKd, intelDispatch);
    } else {
      setOwnData(intelState.server, intelDispatch);
    }
  };
  const saveColumns = () => {
    const fileData = JSON.stringify(intelState.columnVisibility);
    const blob = new Blob([fileData], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = 'utopiaColumns.json';
    link.href = url;
    link.click();
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      {isDesktop && (
        <Button
          variant='text'
          size='small'
          startIcon={<DeleteSweepIcon />}
          onClick={() => intelDispatch({ type: 'RESET_COLS' })}
        >
          Reset
        </Button>
      )}
      <GridToolbarFilterButton />
      {isDesktop && <GridToolbarExport />}
      {isDesktop && (
        <>
          <Button
            variant='text'
            size='small'
            startIcon={<DownloadIcon />}
            onClick={saveColumns}
          >
            Download Cols
          </Button>
          <Button
            component='label'
            variant='text'
            size='small'
            startIcon={<UploadIcon />}
          >
            Upload Cols
            <VisuallyHiddenInput
              type='file'
              accept='application/json'
              onChange={handleFileUpload}
            />
          </Button>
        </>
      )}
      {!isViewingRecent && isDesktop && (
        <Button
          variant='text'
          size='small'
          startIcon={<RefreshIcon />}
          onClick={refreshData}
        >
          Refresh
        </Button>
      )}
    </GridToolbarContainer>
  );
};

export default GridViewToolBar;
